import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    headerLabel1: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    Operation: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' }
        ]
      },
      AccountExtra3: {
        validations: []
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    Reference: {
        validations: [            
          { type: 'required', message: 'Please fill in required field.' }
        ]
    },
    ClientName: {
        validations: []
      },
      eventDate: {
        validations: [
          { type: 'dateinfuture', message: 'Event date must be in the future' },
          { type: 'required', message: 'Please provide an event date' },
        ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    StartTime: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' }
        ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    EndTime: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' }
        ]
    },
    AddressLine1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    PartyName: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' }
        ]
    },
    City: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' },
      ]
    },
    State: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please provide the type of event' },
     ]
    },
    Postal: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
            {
            type: 'label',
            size: 'Medium',
            label: 'Event Request Form',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
        },
  {
    fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Requestor\'s First Name:*',
            mapping: 'firstName'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Client Type:*',
            options: [
              { label: 'Sponsored RSO', value: 'Sponsored RSO' },
              { label: 'Independent RSO', value: 'Independent RSO' },
              { label: 'University', value: 'University' },
              { label: 'Public', value: 'Public' },
              { label: 'Nonprofit', value: 'Nonprofit' },
              { label: 'EMDH', value: 'EMDH' },
            ],
            mapping: 'Operation'
          }
        ]
        },
  {
    fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Requestor\'s Last Name:*',
            mapping: 'lastName'
      },
    {
          type: 'text',
          size: 'Medium',
          label: 'Advisor (if applicable):',
          mapping: 'AccountExtra3'
        }
      ]
      },
{
  fields: [
        {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Do you need catering for the event?:*',
            options: [
              { label: 'Catering Not Needed', value: 'Catering Not Needed' },
              { label: 'TBD', value: 'TBD' },
              { label: 'Breakfast Buffet', value: 'Breakfast Buffet' },
              { label: 'Continential Breakfast', value: 'Continential Breakfast' },
              { label: 'Plated Breakfast', value: 'Plated Breakfast' },
              { label: 'Box Lunch', value: 'Box Lunch' },
              { label: 'Lunch Buffet', value: 'Lunch Buffet' },
              { label: 'Plated Lunch', value: 'Plated Lunch' },
              { label: 'Bar w/ Dinner Buffet', value: 'Bar w/ Dinner Buffet' },
              { label: 'Bar w/ Plated Dinner', value: 'Bar w/ Plated Dinner' },
              { label: 'Dinner Buffet', value: 'Dinner Buffet' },
              { label: 'Plated Dinner', value: 'Plated Dinner' },
              { label: 'Hors D\'ouevres Reception', value: 'Hors D\'ouevres Reception' },
              { label: 'Refreshments/Snacks', value: 'Refreshments/Snacks' },
              { label: 'Multiple Breaks/Meals', value: 'Multiple Breaks/Meals' },
            ],
            mapping: 'Reference'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Organization/Department (if any, please provide full name):',
            mapping: 'ClientName'
          }
        ]
        },
          {
            fields: [
              {
          type: 'date-picker-nofill',
          size: 'Medium',
          label: 'Event Date:*',
          mapping: 'eventDate'
        },
        {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          }
        ]
        },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event Start:*',
                options: [
                    { label: '7:00 AM', value: '07:00:00' },
                    { label: '7:30 AM', value: '07:30:00' },
                    { label: '8:00 AM', value: '08:00:00' },
                    { label: '8:30 AM', value: '08:30:00' },
                    { label: '9:00 AM', value: '09:00:00' },
                    { label: '9:30 AM', value: '09:30:00' },
                    { label: '10:00 AM', value: '10:00:00' },
                    { label: '10:30 AM', value: '10:30:00' },
                    { label: '11:00 AM', value: '11:00:00' },
                    { label: '11:30 AM', value: '11:30:00' },
                    { label: '12:00 PM', value: '12:00:00' },
                    { label: '12:30 PM', value: '12:30:00' },
                    { label: '1:00 PM', value: '13:00:00' },
                    { label: '1:30 PM', value: '13:30:00' },
                    { label: '2:00 PM', value: '14:00:00' },
                    { label: '2:30 PM', value: '14:30:00' },
                    { label: '3:00 PM', value: '15:00:00' },
                    { label: '3:30 PM', value: '15:30:00' },
                    { label: '4:00 PM', value: '16:00:00' },
                    { label: '4:30 PM', value: '16:30:00' },
                    { label: '5:00 PM', value: '17:00:00' },
                    { label: '5:30 PM', value: '17:30:00' },
                    { label: '6:00 PM', value: '18:00:00' },
                    { label: '6:30 PM', value: '18:30:00' },
                    { label: '7:00 PM', value: '19:00:00' },
                    { label: '7:30 PM', value: '19:30:00' },
                    { label: '8:00 PM', value: '20:00:00' },
                    { label: '8:30 PM', value: '20:30:00' },
                    { label: '9:00 PM', value: '21:00:00' },
                ],
                mapping: 'StartTime'
              },
              {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
        },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event End:*',
                options: [
                    { label: '7:30 AM', value: '07:30:00' },
                    { label: '8:00 AM', value: '08:00:00' },
                    { label: '8:30 AM', value: '08:30:00' },
                    { label: '9:00 AM', value: '09:00:00' },
                    { label: '9:30 AM', value: '09:30:00' },
                    { label: '10:00 AM', value: '10:00:00' },
                    { label: '10:30 AM', value: '10:30:00' },
                    { label: '11:00 AM', value: '11:00:00' },
                    { label: '11:30 AM', value: '11:30:00' },
                    { label: '12:00 PM', value: '12:00:00' },
                    { label: '12:30 PM', value: '12:30:00' },
                    { label: '1:00 PM', value: '13:00:00' },
                    { label: '1:30 PM', value: '13:30:00' },
                    { label: '2:00 PM', value: '14:00:00' },
                    { label: '2:30 PM', value: '14:30:00' },
                    { label: '3:00 PM', value: '15:00:00' },
                    { label: '3:30 PM', value: '15:30:00' },
                    { label: '4:00 PM', value: '16:00:00' },
                    { label: '4:30 PM', value: '16:30:00' },
                    { label: '5:00 PM', value: '17:00:00' },
                    { label: '5:30 PM', value: '17:30:00' },
                    { label: '6:00 PM', value: '18:00:00' },
                    { label: '6:30 PM', value: '18:30:00' },
                    { label: '7:00 PM', value: '19:00:00' },
                    { label: '7:30 PM', value: '19:30:00' },
                    { label: '8:00 PM', value: '20:00:00' },
                    { label: '8:30 PM', value: '20:30:00' },
                    { label: '9:00 PM', value: '21:00:00' },
                    { label: '9:30 PM', value: '21:30:00' },
                    { label: '10:00 PM', value: '22:00:00' },
                    { label: '10:30 PM', value: '22:30:00' },
                    { label: '11:00 PM', value: '23:00:00' },
                    { label: '11:30 PM', value: '23:30:00' },
                    { label: '12:00 AM (next day)', value: '00:00:00' },
                    { label: '12:30 AM (next day)', value: '00:30:00' },
                    { label: '1:00 AM (next day)', value: '01:00:00' },
                    { label: '1:30 AM (next day)', value: '01:30:00' },
                    { label: '2:00 AM (next day)', value: '02:00:00' },
                    { label: '2:30 AM (next day)', value: '02:30:00' }
                ],
                mapping: 'EndTime'
              },
              {
            type: 'text',
            size: 'Medium',
            label: 'Street:*',
            mapping: 'AddressLine1'
          }
        ]
        },
          {
            fields: [
              {
            type: 'text',
            size: 'Medium',
            label: 'Name of Event:*',
            mapping: 'PartyName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'City:*',
            mapping: 'City'
          }
        ]
        },
          {
            fields: [
              {
            type: 'text',
            size: 'Medium',
            label: 'Number of Attendees:*',
            mapping: 'plannedguestcount'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:*',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
          }
        ]
        },
          {
            fields: [
              {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:*',
            options: [
              { label: 'Banquet', value: 'Banquet' },
              { label: 'Blood Drive', value: 'Blood Drive' },
              { label: 'Braden Performance', value: 'Braden Performance' },
              { label: 'Breakout', value: 'Breakout' },
              { label: 'BSC Performance', value: 'BSC Performance' },
              { label: 'Cash Bar', value: 'Cash Bar' },
              { label: 'Ceremony', value: 'Ceremony' },
              { label: 'Class/Testing Site', value: 'Class/Testing Site' },
              { label: 'Commencement', value: 'Commencement' },
              { label: 'Competition/Tournament', value: 'Competition/Tournament' },
              { label: 'Concert/Performance', value: 'Concert/Performance' },
              { label: 'Conference', value: 'Conference' },
              { label: 'Concourse Table', value: 'Concourse Table' },
              { label: 'Dance', value: 'Dance' },
              { label: 'Display', value: 'Display' },
              { label: 'EMDH Internal Meeting', value: 'EMDH Internal Meeting' },
              { label: 'Exhibit', value: 'Exhibit' },
              { label: 'Fashion/Talent Show', value: 'Fashion/Talent Show' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'General Session', value: 'General Session' },
              { label: 'Meal', value: 'Meal' },
              { label: 'Meeting', value: 'Meeting' },
              { label: 'Memorial Service', value: 'Memorial Service' },
              { label: 'Movie', value: 'Movie' },
              { label: 'Off-Site Catering', value: 'Off-Site Catering' },
              { label: 'Open House', value: 'Open House' },
              { label: 'Overflow', value: 'Overflow' },
              { label: 'Party/Reception', value: 'Party/Reception' },
              { label: 'Pickup', value: 'Pickup' },
              { label: 'Practice', value: 'Practice' },
              { label: 'Press Conference', value: 'Press Conference' },
              { label: 'Rain Location', value: 'Rain Location' },
              { label: 'Rehearsal', value: 'Rehearsal' },
              { label: 'Speaker', value: 'Speaker' },
              { label: 'Wedding', value: 'Wedding' },
            ],
            mapping: 'theme'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code:*',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Tell us about your event:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Illinois State University Contact Form',
    formId: '418',
    clientKey: '71FAE0D8-370C-4D31-B6AA-B83A09DA155B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day. Please contact the Event Services and Catering office at (309) 438-2222, if you do not hear from us within two business days of submitting.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
